import script from "./AdminRedemptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminRedemptions.vue?vue&type=script&setup=true&lang=ts"

import "./AdminRedemptions.vue?vue&type=style&index=0&id=271cab7c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271cab7c"]])

export default __exports__